import { render, staticRenderFns } from "./SettingAccountPassword.vue?vue&type=template&id=3aaa6792"
import script from "./SettingAccountPassword.vue?vue&type=script&lang=js"
export * from "./SettingAccountPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports